import { logEmailInsightClicked, logFileInsightClicked } from './instrumentationHelpers';
import EmailInsightType from '../store/schema/EmailInsightType';
import FileInsightType from '../store/schema/FileInsightType';
import InsightsDataFetchSource from '../store/schema/InsightsDataFetchSource';
import { ReadingPaneEntrySourceType } from 'owa-calendar-forms-common/lib/schema/ReadingPaneEntrySourceType';
import popoutReadingPane from 'owa-popout/lib/utils/popout/popoutReadingPane';
import { isOpx, getOpxHostApi } from 'owa-opx';

export function openEmailInsight(
    meetingId: string,
    email: EmailInsightType,
    readingPaneEntrySource: ReadingPaneEntrySourceType | null,
    insightsEntrySource: InsightsDataFetchSource
) {
    const { itemId, reactDeeplinkUrl } = email;
    if (itemId) {
        const defaultCallback = () => popoutReadingPane('mail', itemId);
        if (isOpx()) {
            getOpxHostApi().processMeetingInsightsCallback(
                'openEmailInsight',
                {
                    itemId,
                },
                defaultCallback
            );
        } else {
            defaultCallback();
        }
    } else if (reactDeeplinkUrl) {
        window.open(reactDeeplinkUrl);
    }

    logEmailInsightClicked(meetingId, email, readingPaneEntrySource, insightsEntrySource);
}

export function openFileInsight(
    meetingId: string,
    file: FileInsightType,
    readingPaneEntrySource: ReadingPaneEntrySourceType | null,
    insightsEntrySource: InsightsDataFetchSource
) {
    const { reactDeeplinkUrl, fileUrl, fileExtension } = file;
    const defaultCallback = () => window.open(reactDeeplinkUrl);
    if (isOpx()) {
        getOpxHostApi().processMeetingInsightsCallback(
            'openFileInsight',
            {
                fileUrl,
                fileExtension,
                webUrl: reactDeeplinkUrl,
            },
            defaultCallback
        );
    } else {
        defaultCallback();
    }
    logFileInsightClicked(meetingId, file, readingPaneEntrySource, insightsEntrySource);
}
